export const publicKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA7CJxKQyiJuC76Z5xVL1j
Xvm1vvmn4zabhWa4yavYq6UnWsxktQPU6O3YjTBh8uYbxg4jscpdop+iTvNVjFDh
V4pEvb7Sj/uqaYOwvn7YZZ+q9DncT56iUBHIOqnLRVBgb4VY4xod5gtQ4RiZYwKn
EQ1T1qN2/ukONEb57R/mmdiFfzD1+o3mXBMXtUg1JYJ6Ju+y4eIG2zj8WDDIFV++
t5zaO6mz+n0uL/JNIhalFoz5ADJALlouljkYLeoSqrMOUxmh+sO629I0qcSMVrK2
a+BW9E6PKqUyAvhP0/14nBIw1YJ9WiONHk0stMGeQAOs71uy5GTvYf65wPlTdUc1
TwIDAQAB
-----END PUBLIC KEY-----
`;
